



























































export default {
	name: 'SignUp',
	data() {
		const validatePass: Function = (rule, value, callback) => {
			value !== this.newUserForm.password ? callback(new Error('error')) : callback();
		};
		return {
			loading: false,
			loadingText: this.$t('common.loading'),
			organizationData: {
				licensePerUser: true,
				name: false,
				logo: this.$store.state.ramboxLogo,
				providers: {},
			},
			rules: {
				password: [
					{ required: true, message: this.$t('signUp.validation.passwordRequired'), trigger: 'blur' },
					{ min: 6, message: this.$t('signUp.validation.passwordMin'), trigger: 'blur' },
				],
				checkPass: [
					{ required: true, message: this.$t('signUp.validation.confirmRequired'), trigger: 'blur' },
					{ validator: validatePass, message: this.$t('signUp.validation.passwordsDoNotMatch'), trigger: 'blur' },
				],
				firstName: [
					{ required: true, message: this.$t('signUp.validation.firstNameRequired'), trigger: ['blur', 'change'] },
				],
				lastName: [
					{ required: true, message: this.$t('signUp.validation.lastNameRequired'), trigger: ['blur', 'change'] },
				],
			},
		};
	},
	computed: {
		newUserForm(): Object {
			return this.$store.state.newUser;
		},
	},
	methods: {
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.userForm.validate();
			} catch (error) {
				return false;
			}
		},
		async createNewUser(): Promise<void> {
			if (this.loading) return;
			const valid = await this.validateForm();

			if (!valid) return;
			let data = { ...this.newUserForm, workspaceVersion: '2.0.0' };
			delete data.checkPass;
			this.loading = true;
			try {
				await this.$firebase.functions().httpsCallable('createNewUser')(data);
				this.loading = false;
				this.$message({
					type: 'success',
					message: this.$t('signUp.userCreated'),
				});
				this.$store.commit('newUser', {});
				this.$store.dispatch('logout');
				this.$router.push('gettingstarted');
			} catch (error) {
				this.loading = false;
				this.$message({
					type: 'error',
					message: error,
				});
			}
		},
		async getOrganizationInfo(): Promise<void> {
			try {
				this.loading = true;
				this.loadingText = 'Getting Organization Info...';
				const response = await this.$firebase.functions().httpsCallable('getOrganizationInfo')(this.$route.params.id);
				this.organizationData = response.data;
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$emit('organizationName', this.organizationData.name);
			} catch (error) {
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$alert(this.$translateError(error), this.$t('common.error'), {
					confirmButtonText: this.$t('common.ok'),
					callback: action => this.$router.push('/'),
				});
				this.organizationData = this.$options.data.call(this).organizationData;
			}
		},
	},
	mounted() {
		this.$route.params.id && this.getOrganizationInfo();
	},
};
